import { render, staticRenderFns } from "./FormEquipo.vue?vue&type=template&id=e83e7882"
import script from "./FormEquipo.vue?vue&type=script&setup=true&lang=js"
export * from "./FormEquipo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports